import dayjs from 'dayjs';
import { TransitsArchiveFilterValues } from 'store/wim/types/transits';

export const INITIAL_TRANSITS_FILTER_VALUES: Partial<TransitsArchiveFilterValues> = {
  start: dayjs().subtract(1, 'hour').valueOf(),
  end: dayjs().valueOf(),
};
